import React from 'react'
import Link from '../../components/Link'

const BlogPage = () => {
  return (
    <div className="container">
      <div
        className="blog"
        style={{ margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }}
      >
        <Link href="/blog/25-march">&#8592; Previous</Link>
        <h2>Trusting God with Coronavirus</h2>
        <span className="author">by Abi, 31 March 2020</span>
        <p style={{ fontStyle: 'italic' }}>
          Abi is part of our Cornerstone church family and has been unwell with
          suspected Coronavirus. She has now recovered and has shared some
          reflections on what she has been through and her faith in the Lord
          Jesus.
        </p>

        <p>
          Over the past few weeks I've found being a Christian has really helped
          me deal with all the worrying and upsetting situations I've been in.
          Firstly, I find it so comforting to know that God always knows what
          I'm dealing with and He gives me the strength I need to get through
          difficult days. It's so good to know I'm not alone.
        </p>
        <p>
          I've found it really encouraging being able to pray to God knowing
          that He hears me and promises to answer. One verse that I've found
          helpful is Psalm 116 verse 1: "I love the Lord, for he heard my voice;
          he heard my cry for mercy." Most of all, while I'm upset that I may
          not see my friends or family for a few weeks, I'm thankful that I've
          been able to look forward to heaven, where there will be no more
          sickness, and we won't have to be separated from our Christian
          brothers and sisters, but can live together in God's presence.
        </p>
      </div>
    </div>
  )
}

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog/31-march.js